(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1389],{

/***/ 95477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52543);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);








var SIZE = 44;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, color !== 'inherit' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress));

/***/ }),

/***/ 69826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), 'ArrowBack');

exports.Z = _default;

/***/ }),

/***/ 76324:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
}), 'Favorite');

exports.Z = _default;

/***/ }),

/***/ 9025:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorites",
      function () {
        return __webpack_require__(59096);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28889);






var Icon = function(_param) {
    var _color = _param.color, color = _color === void 0 ? "grey.300" : _color, children = _param.children, size = _param.size, Icon = _param.Icon, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "color",
        "children",
        "size",
        "Icon"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        color: color,
        fontSize: size,
        display: "flex",
        justifyContent: "center"
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            fontSize: "inherit"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 59096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ favorites; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Favorite.js
var Favorite = __webpack_require__(76324);
// EXTERNAL MODULE: ./src/hooks/auth/useAuth.ts
var useAuth = __webpack_require__(22291);
// EXTERNAL MODULE: ./src/hooks/search/useSimpleSearch.ts + 1 modules
var useSimpleSearch = __webpack_require__(1470);
// EXTERNAL MODULE: ./src/hooks/mounted/useMounted.ts
var useMounted = __webpack_require__(18063);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/queries/QueryKeys.ts
var QueryKeys = __webpack_require__(11777);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/services/api/ApiService.ts + 19 modules
var ApiService = __webpack_require__(58416);
;// CONCATENATED MODULE: ./src/queries/favorites/useSearchFavorite.ts



var useSearchFavorite = function(term) {
    var ref = (0,es.useQuery)([
        QueryKeys/* QueryKeys.favorites.search */.i.favorites.search(term)
    ], function() {
        return ApiService/* default.searchFavoriteGames */.Z.searchFavoriteGames(term);
    }, {
        enabled: !!term
    }), searchData = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        searchData: searchData !== null && searchData !== void 0 ? searchData : []
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/queries/favorites/useFavorites.ts






var useFavorites = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        enabled: true
    };
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var ref = (0,es.useQuery)(QueryKeys/* QueryKeys.allgames.favorites */.i.allgames.favorites(), function() {
        return ApiService/* default.getFavoriteGames */.Z.getFavoriteGames();
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        enabled: isLoggedIn && options.enabled
    })), games = ref.data, isLoading = ref.isLoading, error = ref.error;
    return {
        isLoading: isLoading,
        hasError: !!error,
        games: games,
        isEmpty: !isLoading && !!games && games.length === 0
    };
};

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/components/@common/Background/Background.tsx
var Background = __webpack_require__(68224);
// EXTERNAL MODULE: ./src/components/@common/ContentCard/Loading/LoadingContentCard.tsx + 4 modules
var LoadingContentCard = __webpack_require__(41242);
// EXTERNAL MODULE: ./src/components/@common/Icon/Icon.tsx
var Icon = __webpack_require__(72721);
// EXTERNAL MODULE: ./src/components/@common/Search/SearchEmptyState/SearchEmptyState.tsx
var SearchEmptyState = __webpack_require__(78670);
// EXTERNAL MODULE: ./src/components/@common/Search/SearchInput/SearchInput.tsx
var SearchInput = __webpack_require__(38825);
;// CONCATENATED MODULE: ./src/components/@favorites/Empty/Empty.tsx





var Empty = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        flex: 1,
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                color: "grey.300",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorite/* default */.Z, {
                    fontSize: "large",
                    color: "inherit"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                my: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "favorites.empty.title"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                color: "textSecondary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "favorites.empty.body"
                })
            })
        ]
    });
};
/* harmony default export */ var Empty_Empty = (Empty);

// EXTERNAL MODULE: ./src/components/@game-detail/Section/GameSection.tsx + 2 modules
var GameSection = __webpack_require__(65943);
// EXTERNAL MODULE: ./src/components/@home/NotLoggedInCta/NotLoggedInCta.tsx
var NotLoggedInCta = __webpack_require__(14357);
// EXTERNAL MODULE: ./src/components/@layout/NavigationLayout/NavigationLayout.tsx + 12 modules
var NavigationLayout = __webpack_require__(18039);
// EXTERNAL MODULE: ./src/components/@navigation/HeaderSimple/HeaderSimple.tsx
var HeaderSimple = __webpack_require__(17854);
;// CONCATENATED MODULE: ./src/pages/favorites/index.tsx





















var Discover = function() {
    var isLoggedIn = (0,useAuth/* useAuth */.a)().isLoggedIn;
    var intl = (0,useIntl/* default */.Z)();
    var ref = useFavorites(), games = ref.games, favoritesIsLoading = ref.isLoading, isEmpty = ref.isEmpty;
    var ref1 = (0,useSimpleSearch/* useSimpleSearch */.G)(), currentValue = ref1.currentValue, debouncedValue = ref1.debouncedValue, searchChange = ref1.searchChange, searchClear = ref1.searchClear;
    var ref2 = useSearchFavorite(debouncedValue), searchData = ref2.searchData, searchIsLoading = ref2.isLoading;
    var isMounted = (0,useMounted/* default */.Z)();
    var isLoading = favoritesIsLoading || !isMounted;
    var render = function() {
        if (isLoading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mt: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        component: "h1",
                        color: "textPrimary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "favorites.title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 4,
                        children: (0,_to_consumable_array/* default */.Z)(new Array(8)).map(function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContentCard/* default */.Z, {
                                    type: "sm"
                                })
                            }, index);
                        })
                    })
                ]
            });
        } else if (!isLoggedIn) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                height: "100%",
                alignItems: "center",
                display: "flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotLoggedInCta/* default */.ZP, {
                    textAlign: "center",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        size: 56,
                        Icon: Favorite/* default */.Z
                    }),
                    title: intl.formatMessage({
                        id: "favorites.login.title"
                    }),
                    description: intl.formatMessage({
                        id: "favorites.login.description"
                    }),
                    titleVariant: "h5"
                })
            });
        } else if (isEmpty) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty_Empty, {});
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSimple/* default */.Z, {
                        noBack: true,
                        rightItems: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                            value: currentValue,
                            onChange: searchChange,
                            onClear: searchClear,
                            fullWidth: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mt: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h4",
                                    component: "h1",
                                    color: "textPrimary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "favorites.title"
                                    })
                                })
                            }),
                            !!debouncedValue && searchIsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 16,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    size: 24
                                })
                            }),
                            !!debouncedValue && !searchIsLoading && !searchData.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 16,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchEmptyState/* default */.Z, {
                                    value: currentValue,
                                    onClear: searchClear
                                })
                            }),
                            games && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameSection/* default */.Z, {
                                id: "favorites",
                                data: debouncedValue ? searchData : games,
                                variant: "detail",
                                imagesAboveFold: true,
                                disablePadding: true
                            })
                        ]
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: intl.formatMessage({
                    id: "seo.title.favorites"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "main",
                height: "100%",
                mb: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "sm",
                    style: {
                        height: "100%"
                    },
                    children: render()
                })
            })
        ]
    });
};
// @ts-ignore
Discover.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationLayout/* default */.Z, {
        headerVariant: "none",
        children: page
    });
};
/* harmony default export */ var favorites = (Discover);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9282,1743,7594,8054,8039,8926,9774,2888,179], function() { return __webpack_exec__(9025); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);